import RateCard from "./RateCard";

const SeasonalPricingSection = ({
  categoryId,
  isEnabled,
  savedRates,
  colors,
  calculateBalance,
  formatDate,
  weekdays,
  onAddSeasonal,
  onEditRate,
  onDeleteRate,
}) => {
  const categoryRates = savedRates.filter((r) => r.accordionId === categoryId);
  const hasRates = categoryRates.length > 0;

  return (
    <section
      className={`rounded-xl border border-gray-100 bg-slate-50/40 p-5 ${
        !isEnabled ? "opacity-40 pointer-events-none" : ""
      }`}
    >
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4">
        <div>
          <h3 className="text-sm font-bold text-gray-900">
            Booking rates
          </h3>
          <p className="text-sm text-gray-500 mt-0.5">
            Add seasonal rates for specific date ranges.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            type="button"
            onClick={onAddSeasonal}
            disabled={!isEnabled}
            className="px-3 py-1.5 text-xs font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            + Seasonal rate
          </button>
        </div>
      </div>

      {!isEnabled && (
        <p className="text-sm text-amber-600 mb-3">
          Complete base price for this stay category to add booking rates.
        </p>
      )}

      {hasRates ? (
        <div className="border border-gray-100 rounded-lg divide-y divide-gray-50">
          {categoryRates.map((rate) => (
            <RateCard
              key={
                rate.id ||
                `${rate.accordionId}-${rate.startDate}-${rate.rateType}`
              }
              rate={rate}
              colors={colors}
              calculateBalance={calculateBalance}
              formatDate={formatDate}
              weekdays={weekdays}
              onEdit={onEditRate}
              onDelete={onDeleteRate}
            />
          ))}
        </div>
      ) : (
        <div className="py-8 text-center border border-dashed border-gray-200 rounded-lg">
          <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-gray-50 mb-2">
            <i className="fi fi-rr-calendar-plus text-lg text-gray-400"></i>
          </div>
          <p className="text-sm text-gray-600 font-medium">No rates yet</p>
          <p className="text-xs text-gray-500 mt-1">
            Add a seasonal rate for date-specific pricing
          </p>
        </div>
      )}
    </section>
  );
};

export default SeasonalPricingSection;
